import React from 'react';
import { Card, CardContent } from '../../../shared/components/ui/Card';

/**
 * RewardAnalytics - Displays reward analytics metrics
 * @param {Object} props
 * @param {Object} props.analytics - Analytics data object
 */
export function RewardAnalytics({ analytics }) {
    if (!analytics) {
        return null;
    }

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 mb-6">
            <Card>
                <CardContent className="p-3 sm:p-4">
                    <p className="text-xs sm:text-sm text-gray-500 line-clamp-2">Total Redemptions</p>
                    <p className="text-lg sm:text-2xl font-semibold text-primary mt-1">
                        {analytics.totalRedemptions}
                    </p>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="p-3 sm:p-4">
                    <p className="text-xs sm:text-sm text-gray-500 line-clamp-2">Top Reward</p>
                    <p className="text-lg sm:text-2xl font-semibold text-primary mt-1 line-clamp-2" title={`${analytics.topRewardRedemptions} - ${analytics.topReward}`}>
                        {analytics.topRewardRedemptions} - {analytics.topReward}
                    </p>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="p-3 sm:p-4">
                    <p className="text-xs sm:text-sm text-gray-500 line-clamp-2">Points Spent</p>
                    <p className="text-lg sm:text-2xl font-semibold text-primary mt-1">
                        {`${analytics.pointsSpent} pts`}
                    </p>
                </CardContent>
            </Card>
        </div>
    );
}

